export default function formatMessageDate(dateString: string): string {
    const moscowFormatter = new Intl.DateTimeFormat('ru-RU', {
        timeZone: 'Europe/Moscow',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    const moscowWeekdayFormatter = new Intl.DateTimeFormat('ru-RU', {
        timeZone: 'Europe/Moscow',
        weekday: 'long',
    });

    const now = new Date();
    const messageDate = new Date(dateString);

    const nowMoscow = new Date(
        new Intl.DateTimeFormat('en-US', {
            timeZone: 'Europe/Moscow',
            hour12: false,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(now)
    );

    const messageMoscow = new Date(
        new Intl.DateTimeFormat('en-US', {
            timeZone: 'Europe/Moscow',
            hour12: false,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(messageDate)
    );

    const diffInDays = Math.floor(
        (nowMoscow.getTime() - messageMoscow.getTime()) / (1000 * 60 * 60 * 24)
    );

    if (diffInDays === 0) {
        return 'Сегодня';
    } else if (diffInDays === 1) {
        return 'Вчера';
    } else if (diffInDays < 7 && messageMoscow.getFullYear() === nowMoscow.getFullYear()) {
        return moscowWeekdayFormatter.format(messageDate); // Понедельник, Вторник...
    } else {
        return moscowFormatter.format(messageDate);
    }
}
